import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';
import { removeCookie } from '../../utils/cookieUtils';

type SignOutAccountState = {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: SignOutAccountState = {
  loading: false,
  error: false,
  errorMessage: '',
  data: null,
};

export const signOutAccount = createAsyncThunk<unknown>(
  'signOutAccount',
  async () => {
    const { data } = await api.post('/api/account/signout');
    return data;
  }
);

const signOutAccountSlice = createSlice({
  name: 'signOutAccount',
  initialState,
  reducers: {
    resetSignOutAccount: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signOutAccount.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(signOutAccount.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      
      // Clear access token from cookie
      removeCookie('access_token');
      removeCookie('refresh_token');
      removeCookie('ElevateToken');
      
      // Clear localStorage as fallback cleanup
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    });
    builder.addCase(signOutAccount.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to sign out.';
    });
  },
});

export const { resetSignOutAccount } = signOutAccountSlice.actions;
export default signOutAccountSlice.reducer;
